import { NonUserEmails } from '../../../cimsPage/instances/admin'
import { CreateViewEditRemove } from '../../common'

const nonUserEmails = CreateViewEditRemove({
  page: NonUserEmails,
  object: 'Non User Email',
  create: '89D075EF-89D1-44DA-8518-3F4D6252047C',
  view: 'EEB94BD7-83DD-47C8-964F-DDA0B6FE27F9',
  edit: 'EBEBE8F1-C3F5-4B95-97F4-E064BD2A35AE',
  remove: '983BDF94-8938-463F-B755-CB24737533D8',
})

export const CreateNonUserEmail = nonUserEmails.Create
export const ViewNonUserEmail = nonUserEmails.View
export const EditNonUserEmail = nonUserEmails.Edit
export const RemoveNonUserEmail = nonUserEmails.Remove

export type NonUserEmailPermission =
  | typeof CreateNonUserEmail
  | typeof ViewNonUserEmail
  | typeof EditNonUserEmail
  | typeof RemoveNonUserEmail
